import { CircleStop, Play } from "lucide-react";
import React from "react";

interface ConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  message: string;
}

const ConfirmationDialog = ({ isOpen, onClose, onConfirm, message }: ConfirmationDialogProps) => {
  const ref = React.useRef<HTMLDivElement | null>(null);

   

  if (!isOpen) return null;

  return (
    <div onClick={(e)=> e.preventDefault()} className="fixed inset-0 z-[5000] flex gap-2 items-center justify-center backdrop-blur-sm bg-black/55 pointer-events-auto">
      <div
        ref={ref}
        className="p-6 rounded-lg bg-white dark:bg-gray-900 shadow-lg w-80"
      >
        <h2 className="text-lg font-semibold dark:text-slate-200 text-gray-800">Confirm Closing</h2>
        <p className="text-gray-600 dark:text-slate-300 mt-2">{message}</p>
        <div className="mt-4 flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 flex items-center gap-2 text-gray-700 rounded-md hover:bg-gray-400"
          >
            <Play size={18} /> Resume
          </button>
          <button
            onClick={onConfirm}
            className="px-8 py-2 flex items-center gap-2 md:text-base text-xs bg-red-500 text-white rounded-md hover:bg-red-600"
          >
            <CircleStop size={18} /> Stop
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
